utils = {
    /**
     * Get the name of the correct 'transitionend' event for the browser we're in
     *
     * @return {string}
     */
    whichTransitionEnd: function() {
        var t;
        var el = document.createElement('fakeelement');
        var transitions = {
            'transition':'transitionend',
            'OTransition':'oTransitionEnd',
            'MozTransition':'transitionend',
            'WebkitTransition':'webkitTransitionEnd'
        };

        for(t in transitions){
            if( el.style[t] !== undefined ){
                return transitions[t];
            }
        }
    },

    isTouchDevice: function() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function (query) {
            return window.matchMedia(query).matches;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    },
};

module.exports = utils;



//////////////////
// WEBPACK FOOTER
// ./utilities/js/utils.js
// module id = 2
// module chunks = 3